module.exports = __webpack_public_path__ + "static/img/已通过.ecc8c78b.png";